/**
 * DevSelector — Solo visible en localhost (desarrollo local).
 * Permite simular ambos contextos sin cambiar el Host real.
 */
import { useState } from "react";

const DEFAULT_TENANT = "demo"; // subdominio de prueba

export default function DevSelector() {
    const [sub, setSub] = useState(DEFAULT_TENANT);

    const goToShell = () => {
        // Simula sass.local: guardamos el modo en sessionStorage
        sessionStorage.setItem("dev_mode", "shell");
        window.location.reload();
    };

    const goToTenant = () => {
        const slug = sub.trim().toLowerCase().replace(/[^a-z0-9-]/g, "") || DEFAULT_TENANT;
        // Simula {sub}.sass.local apuntando al mismo localhost
        sessionStorage.setItem("dev_mode", "tenant");
        sessionStorage.setItem("dev_subdomain", slug);
        window.location.reload();
    };

    return (
        <div style={s.root}>
            <div style={s.card}>
                {/* Badge */}
                <div style={s.badge}>🛠 LOCAL DEV</div>

                <h1 style={s.title}>SaaS POS — Entorno local</h1>
                <p style={s.subtitle}>
                    Estás en <code style={s.code}>localhost</code>. Elige qué contexto quieres simular.
                </p>

                <div style={s.grid}>
                    {/* SaaS Shell */}
                    <button id="dev-btn-shell" onClick={goToShell} style={s.btn}>
                        <div style={s.btnIcon}>🌐</div>
                        <div>
                            <div style={s.btnTitle}>SaaS Shell</div>
                            <div style={s.btnSub}>Landing · Pricing · Onboarding</div>
                            <div style={s.btnMeta}>Simula <code>sass.local</code></div>
                        </div>
                    </button>

                    {/* Tenant App */}
                    <button id="dev-btn-tenant" onClick={goToTenant} style={{ ...s.btn, ...s.btnTenant }}>
                        <div style={s.btnIcon}>🍽️</div>
                        <div>
                            <div style={s.btnTitle}>Tenant App</div>
                            <div style={s.btnSub}>TPV · Admin · POS · Cocina</div>
                            <div style={s.btnMeta}>Simula <code>{sub || "demo"}.sass.local</code></div>
                        </div>
                    </button>
                </div>

                {/* Tenant slug input */}
                <div style={s.inputRow}>
                    <label style={s.label}>Subdominio de tenant:</label>
                    <input
                        id="dev-subdomain-input"
                        value={sub}
                        onChange={(e) => setSub(e.target.value)}
                        placeholder="demo"
                        style={s.input}
                    />
                </div>

                <p style={s.hint}>
                    Para usar dominios reales, edita <code>C:\Windows\System32\drivers\etc\hosts</code> y
                    añade <code>127.0.0.1 sass.local</code> y <code>127.0.0.1 demo.sass.local</code>
                </p>
            </div>
        </div>
    );
}

const s = {
    root: {
        minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
        fontFamily: "'Inter', system-ui, sans-serif", padding: "2rem",
    },
    card: {
        background: "rgba(255,255,255,0.05)", backdropFilter: "blur(20px)",
        border: "1px solid rgba(255,255,255,0.1)", borderRadius: "1.5rem",
        padding: "2.5rem", maxWidth: "600px", width: "100%",
        boxShadow: "0 25px 50px rgba(0,0,0,0.5)",
    },
    badge: {
        display: "inline-block", background: "rgba(234,179,8,0.2)",
        border: "1px solid rgba(234,179,8,0.4)", color: "#EAB308",
        fontSize: "0.75rem", fontWeight: "700", letterSpacing: "0.1em",
        borderRadius: "9999px", padding: "0.25rem 0.75rem", marginBottom: "1.25rem",
    },
    title: { color: "#fff", fontSize: "1.75rem", fontWeight: "800", margin: "0 0 0.5rem" },
    subtitle: { color: "#94a3b8", fontSize: "0.95rem", margin: "0 0 2rem" },
    code: { fontFamily: "monospace", color: "#EAB308" },
    grid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem", marginBottom: "1.5rem" },
    btn: {
        display: "flex", gap: "0.875rem", alignItems: "flex-start", textAlign: "left",
        background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)",
        borderRadius: "1rem", padding: "1.25rem", cursor: "pointer",
        transition: "all 0.2s", color: "inherit",
    },
    btnTenant: { background: "rgba(234,179,8,0.08)", borderColor: "rgba(234,179,8,0.25)" },
    btnIcon: { fontSize: "1.75rem", flexShrink: 0 },
    btnTitle: { color: "#fff", fontWeight: "700", fontSize: "1rem", marginBottom: "0.2rem" },
    btnSub: { color: "#94a3b8", fontSize: "0.78rem", marginBottom: "0.4rem" },
    btnMeta: { color: "#64748b", fontSize: "0.72rem", fontFamily: "monospace" },
    inputRow: { display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "1.5rem" },
    label: { color: "#94a3b8", fontSize: "0.85rem", whiteSpace: "nowrap" },
    input: {
        flex: 1, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.12)",
        borderRadius: "0.5rem", padding: "0.5rem 0.75rem", color: "#EAB308",
        fontFamily: "monospace", fontSize: "0.9rem", outline: "none",
    },
    hint: {
        color: "#475569", fontSize: "0.72rem", lineHeight: 1.6,
        borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: "1rem",
    },
};
